{% block swag_migration_dashboard_card %}
    <mt-card
        class="swag-migration-dashboard-card"
        position-identifier="swag-migration-dashboard-card"
    >
        {% block swag_migration_dashboard_card_wrapper %}
            {% block swag_migration_dashboard_card_title %}
                <template #title>
                    <span class="swag-migration-dashboard-card__title">
                        {{ $tc('swag-migration.dashboard.title') }}
                    </span>
                </template>
            {% endblock %}

            {% block swag_migration_dashboard_card_container %}
                <sw-container
                    class="swag-migration-shop-information"
                    rows="auto auto"
                >
                    {% block swag_migration_dashboard_card_content %}
                        <div class="swag-migration-dashboard-card__content">
                            {% block swag_migration_dashboard_card_wrapper %}
                                <div class="swag-migration-dashboard-card__wrapper">
                                    {% block swag_migration_dashboard_card_left_content %}
                                        <div class="swag-migration-dashboard-card__left-content">
                                            {% block swag_migration_dashboard_card_headline %}
                                                <div class="swag-migration-dashboard-card__headline">
                                                    {{ $tc('swag-migration.dashboard.headline') }}
                                                </div>
                                            {% endblock %}

                                            {% block swag_migration_dashboard_card_information %}
                                                <div class="swag-migration-dashboard-card__information">
                                                    {{ $tc('swag-migration.dashboard.information') }}
                                                </div>
                                            {% endblock %}

                                            {% block swag_migration_dashboard_card_button %}
                                                <mt-button variant="primary"
                                                           @click="goToMigrationIndexPage"
                                                >
                                                    {{ $tc('swag-migration.dashboard.button') }}
                                                </mt-button>
                                            {% endblock %}
                                        </div>
                                    {% endblock %}

                                    {% block swag_migration_dashboard_card_right_content %}
                                        <div class="swag-migration-dashboard-card__right-content">
                                            <img
                                                :src="assetFilter('/swagmigrationassistant/administration/static/img/wizard-introduction.svg')"
                                                alt=""
                                            />
                                        </div>
                                    {% endblock %}
                                </div>
                            {% endblock %}
                        </div>
                    {% endblock %}
                </sw-container>
            {% endblock %}
        {% endblock %}
    </mt-card>
{% endblock %}
